<template>
  <div v-if="visible" class="ml-3">
    <v-row v-if="image" class="mb-2">
      <v-col cols="2">
        <v-img
          :src="image"
          class="profile-picture"
          min-width="25px"
          max-width="40px"
          contain
        />
      </v-col>
      <v-col class="link-header" cols="10">
        <p class="my-auto">
          {{ title }}
          <v-badge color="primary" v-if="expandable" :content="`${items ? items.length : 0}`" class="mr-5 ml-1" />
          <font-awesome-icon
            v-if="expandable"
            :icon="expanded ? 'chevron-up' : 'chevron-down'"
            v-on:click="toggleExpanded"
            color="primary"
            size="xs"
          />
        </p>
      </v-col>
    </v-row>
    <v-row v-else class="mb-2">
      <v-col cols="12">
        <h2 v-if="!image">
          {{ title }}
          <v-badge color="primary" v-if="expandable" :content="`${items ? items.length : 0}`" class="mr-5 ml-1" />
          <font-awesome-icon
            v-if="expandable"
            :icon="expanded ? 'chevron-up' : 'chevron-down'"
            v-on:click="toggleExpanded"
            color="primary"
            size="xs"
          />
        </h2>
      </v-col>
    </v-row>
    <div v-if="!expandable || (expandable && expanded)">
      <div v-for="(item, index) in items" :key="`${index}`" class="link-list">
        <v-row v-if="visibleItem(item.forMembers)" class="mb-1">
          <v-col v-if="item.image" cols="2">
            <v-img
              :src="item.image"
              class="profile-picture"
              min-width="25px"
              max-width="40px"
              contain
            />
          </v-col>
          <v-col class="my-auto" :cols="item.image ? 10 : 12">
            <font-awesome-icon v-if="item.icon" :icon="item.icon" />
            <router-link
              v-if="item.link"
              v-bind:to="item.link"
              class="link"
              v-bind:class="{
                'styled-link': item.icon || item.image,
                bold: item.image,
              }"
            >
              {{ item.text }}{{ "&nbsp;&nbsp;" }}
              <v-badge
                color="primary"
                v-if="item.count > 0"
                :content="item.count"
              />
            </router-link>
            <a
              v-else-if="item.to"
              :href="item.to"
              target="_blank"
              class="link"
              v-bind:class="{
                'styled-link': item.icon || item.image,
                bold: item.image,
              }"
            >
              {{ item.text }}{{ "&nbsp;&nbsp;" }}
              <v-badge
                color="primary"
                v-if="item.count > 0"
                :content="item.count"
              />
            </a>
            <span v-else>
              {{ item.text }}{{ "&nbsp;&nbsp;" }}
              <v-badge
                color="primary"
                v-if="item.count > 0"
                :content="item.count"
              />
            </span>
          </v-col>
        </v-row>
      </div>
    </div>
    <hr color="lightGray" class="mt-4" />
  </div>
</template>

<script lang="ts">
import Vue, { PropType } from "vue";
import { UserInfo } from "@/types/User";
import { MemberType } from "@/types/Member";
import canView from "@/helpers/can-view-summary-item";

export default Vue.extend({
  name: "MenuLinkSummary",
  props: {
    forMembers: [Boolean, Array] as PropType<boolean | MemberType[]>,
    image: String,
    title: String,
    expandable: Boolean,
    count: Object as () => number,
    items: {
      type: Array,
      default: () => [{ text: "", icon: null, link: "", image: null }],
    },
  },
  data: function () {
    return {
      expanded: false,
    };
  },
  computed: {
    userInfo(): UserInfo {
      return this.$store.state.userInfo;
    },
    visible(): boolean {
      return !!this.userInfo && canView(
        this.userInfo.memberType,
        this.userInfo.hasNeverBeenMember,
        this.forMembers,
      );
    },
  },
  methods: {
    toggleExpanded() {
      this.expanded = !this.expanded;
    },
    visibleItem(forMembers?: boolean | MemberType[]): boolean {
      return !!this.userInfo && canView(
        this.userInfo.memberType,
        this.userInfo.hasNeverBeenMember,
        forMembers,
      );
    }
  },
});
</script>
